export const EFSTADETaxRates = [
  { rate: 19, name: 'Normal', group: 'A' },
  { rate: 7, name: 'Reduced', group: 'B' },
  { rate: 10.7, name: 'Average tax rate (§24(1)Nr.3 UStG)', group: 'C' },
  { rate: 5.5, name: 'Average tax rate (§24(1)Nr.1 UStG)', group: 'D' },
  { rate: 0, name: 'Not taxable', group: 'E' },
  { rate: 0, name: 'VAT-exempt', group: 'F' },
  { rate: 0, name: 'Tax rate can not be determined', group: 'G' },
  { rate: 16, name: 'Corona Normal', group: 'H' },
  { rate: 5, name: 'Corona Ermässigt', group: 'I' },
];
